import { Checkbox as CheckboxPrimitive } from "@base-ui/react/checkbox"
import { CheckIcon, MinusIcon } from "lucide-react"

import { cn } from "@/lib/utils"

type CheckboxValue = boolean | "indeterminate"

interface CheckboxProps
  extends Omit<CheckboxPrimitive.Root.Props, "checked" | "defaultChecked" | "onCheckedChange"> {
  checked?: CheckboxValue
  defaultChecked?: CheckboxValue
  onCheckedChange?: (checked: boolean) => void
}

function Checkbox({
  className,
  checked,
  defaultChecked,
  onCheckedChange,
  ...props
}: CheckboxProps) {
  const indeterminate = checked === "indeterminate"
  const resolvedChecked = checked === "indeterminate" ? false : checked
  const resolvedDefault =
    defaultChecked === "indeterminate" ? false : defaultChecked

  return (
    <CheckboxPrimitive.Root
      data-slot="checkbox"
      checked={resolvedChecked}
      defaultChecked={resolvedDefault}
      indeterminate={indeterminate || undefined}
      onCheckedChange={(value) => onCheckedChange?.(value)}
      className={cn(
        "peer group/checkbox inline-flex size-4 shrink-0 items-center justify-center rounded-[4px] border border-input bg-background text-primary-foreground shadow-xs outline-none transition-colors focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50 disabled:cursor-not-allowed disabled:opacity-50 data-checked:border-primary data-checked:bg-primary data-indeterminate:border-primary data-indeterminate:bg-primary",
        className,
      )}
      {...props}
    >
      <CheckboxPrimitive.Indicator
        data-slot="checkbox-indicator"
        className="flex items-center justify-center text-current"
      >
        <CheckIcon className="size-3.5 group-data-indeterminate/checkbox:hidden" />
        <MinusIcon className="hidden size-3.5 group-data-indeterminate/checkbox:block" />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  )
}

export { Checkbox }
